/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_filter_dropdown_no_resource_type28 = /** @type {(inputs: {}) => string} */ () => {
	return `No type filter…`
};

const fr_filter_dropdown_no_resource_type28 = /** @type {(inputs: {}) => string} */ () => {
	return `Aucun filtre de type…`
};

const de_filter_dropdown_no_resource_type28 = /** @type {(inputs: {}) => string} */ () => {
	return `Kein Typfilter…`
};

const es_filter_dropdown_no_resource_type28 = /** @type {(inputs: {}) => string} */ () => {
	return `Sin filtro de tipo…`
};

const it_filter_dropdown_no_resource_type28 = /** @type {(inputs: {}) => string} */ () => {
	return `Nessun filtro di tipo…`
};

const ar_filter_dropdown_no_resource_type28 = /** @type {(inputs: {}) => string} */ () => {
	return `لا يوجد مرشح نوع…`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const filter_dropdown_no_resource_type28 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.filter_dropdown_no_resource_type28(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("filter_dropdown_no_resource_type28", locale)
	if (locale === "en") return en_filter_dropdown_no_resource_type28(inputs)
	if (locale === "fr") return fr_filter_dropdown_no_resource_type28(inputs)
	if (locale === "de") return de_filter_dropdown_no_resource_type28(inputs)
	if (locale === "es") return es_filter_dropdown_no_resource_type28(inputs)
	if (locale === "it") return it_filter_dropdown_no_resource_type28(inputs)
	return ar_filter_dropdown_no_resource_type28(inputs)
};
export { filter_dropdown_no_resource_type28 as "FILTER_DROPDOWN_NO_RESOURCE_TYPE" }